/* eslint-disable no-redeclare */
import { z } from 'zod';

import { PlateName } from './plate-name';
import { SurveyAnswers } from './survey-answers';

export const PlateSubmission = z.object({
  plateName: PlateName,
  surveyAnswers: SurveyAnswers.partial(),
});

export type PlateSubmission = z.infer<typeof PlateSubmission>;

export const PlateTransition = z.object({
  nextPlate: PlateName,
});

export type PlateTransition = z.infer<typeof PlateTransition>;
